<template>
  <b-form-group
    label="Durum"
    label-for="status"
  >
    <validation-provider
      #default="{ errors }"
      name="Durum"
      rules="required"
    >
      <v-select
        id="status"
        v-model="dataItem.status"
        label="title"
        :options="statuses"
        :reduce="item => item.id"
        placeholder="Seçiniz"
        :clearable="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CategorySelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    statuses() {
      return [
        {
          id: '1',
          title: 'Aktif',
        },
        {
          id: '0',
          title: 'Pasif',
        },
      ]
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>
